import { createFileRoute } from "@tanstack/react-router";
import { Heading } from "@/components/ui/heading";

export const Route = createFileRoute("/_home/colors")({
  component: RouteComponent,
});

// display all the colors in the theme
// primary, secondary, tertiary
// warning, success, error

function ColorSwatch({
  name,
  bgClass,
  textClass,
}: { name: string; bgClass: string; textClass: string }) {
  return (
    <div className="flex flex-col gap-2">
      <div className={`w-32 h-32 rounded-lg shadow-md ${bgClass}`} />
      <div className={`text-sm font-medium ${textClass}`}>{name}</div>
      <div className="text-xs text-muted-foreground">{bgClass}</div>
    </div>
  );
}

function RouteComponent() {
  const colorGroups = [
    {
      title: "Primary Health Colors",
      colors: [
        { name: "Vitality Blue", bgClass: "bg-primary", textClass: "text-primary" },
        { name: "Health Green", bgClass: "bg-secondary", textClass: "text-secondary" },
        { name: "Wellness Teal", bgClass: "bg-tertiary", textClass: "text-tertiary" },
      ],
    },
    {
      title: "Status Colors",
      colors: [
        { name: "Success", bgClass: "bg-success", textClass: "text-success" },
        { name: "Warning", bgClass: "bg-warning", textClass: "text-warning" },
        { name: "Error", bgClass: "bg-destructive", textClass: "text-destructive" },
      ],
    },
  ];

  return (
    <div className="col-span-12 p-8 space-y-8">
      <Heading level="h1" size="h3" className="mb-6">
        Health App Color Palette
      </Heading>

      {colorGroups.map((group) => (
        <div key={group.title} className="space-y-4">
          <Heading level="h2" size="h4">
            {group.title}
          </Heading>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {group.colors.map((color) => (
              <ColorSwatch key={color.name} {...color} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
